import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image, Form, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./signin-email.css";

import responsivebg from "../../assets/images/responsive-bg.png";

import backarrow from "../../assets/images/backarrow.jpg";
import logo from "../../assets/images/MTDlogo.png";

import { API_URL } from "../../api";
import { useAlert } from "../../Context/AlertModalContext";
import IconButton from "../userflow/components/card/IconButton";

export const SignInEmail = () => {
  const navigate = useNavigate();
  const alert = useAlert();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes("@")) {
      alert.setModal({
        title: "",
        message: "Please enter a valid email address.",
        show: true,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}user/login/email-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setLoading(false);
        setErrorMessage("*" + data.message + ".");
        alert.setModal({
          title: "",
          message: `${data.message || "Failed to send OTP. Please try again."}`,
          show: true
        });
        return;
      }
      navigate("/signinemailotp", { state: { email } });
      setEmail("");
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="signin-emailverify-container">
      <div className="signin-emailverify-bg">
        <Image className="responsive-bg" src={responsivebg}></Image>
      </div>
      <Container className="signin-emailverify-main">
        <Container className="signin-emailverify-box">
          <Container className="logo-progressbar3">
            <Container className="logo-arrow3">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
          </Container>

          <Container className="signin-emailverify-text">
            <IconButton type="envelope" onClick={e => e.stopPropagation()} />
          </Container>
          <Form onSubmit={handleSubmit} className="signin-emailverify-form">
            <Container className="signin-emailverify-content">
              <div style={{ width: "100%", alignItems: "center" }}>
                <Form.Group
                  controlId="formCode"
                  className="signin-emailverify-form-group"
                >
                  <Form.Label className="signin-emailverify-lable">
                    {" "}
                    Enter your email
                  </Form.Label>

                  <Form.Control
                    className={`signin-emailverify-input ${errorMessage ? "error" : ""
                      }`}
                    type="text"
                    style={{ flex: 1 }}
                    placeholder="Example@gmail.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <div style={{ marginTop: "5px" }}>
                    {errorMessage && (
                      <Form.Text className="text-danger error-message">
                        {errorMessage}
                      </Form.Text>
                    )}
                  </div>
                </Form.Group>
              </div>
              <button
                type="submit"
                className="global-next-btn"
                disabled={loading} // Disable button when loading
              >
                {loading ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  "Next"
                )}
              </button>
            </Container>
          </Form>
        </Container>
      </Container>
    </div>
  );
};
